import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import TimeSlotModal from '../Modals/TimeSlotModal'

const WEEK_DAY_KEYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

const TimeSlots: React.FC = () => {
  const { timeSlotsModal, setTimeSlotsModal, leagueData, timeSlots, setTimeSlots } =
    leagueEventStore(store => ({
      timeSlotsModal: store.timeSlotsModal,
      setTimeSlotsModal: store.setTimeSlotsModal,
      leagueData: store.leagueData,
      timeSlots: store.timeSlots,
      setTimeSlots: store.setTimeSlots,
    }))

  const openModal = () => {
    // Hydrate the store with the saved day arrays so the checkboxes/slots
    // re-populate on reopen. leagueData.timeSlots also carries non-day keys
    // (minsBetweenGames, venueId, _id, ...) so pick weekday keys only.
    // Only hydrate when the store is empty to avoid clobbering active edits.
    if (!timeSlots && leagueData?.timeSlots) {
      const src: any = leagueData.timeSlots
      const hydrated: any = {}
      WEEK_DAY_KEYS.forEach(day => {
        if (Array.isArray(src[day]) && src[day].length > 0) hydrated[day] = src[day]
      })
      if (Object.keys(hydrated).length) setTimeSlots(hydrated)
    }
    setTimeSlotsModal(true)
  }

  return (
    <>
      <div onClick={openModal}>
        <IconsTextNavigation
          iconName="CalendarX"
          heading="Time Slots"
          isCompleted={leagueData.statuses.roundRobinsStatuses.timeSlots}
        />
      </div>

      {timeSlotsModal && <TimeSlotModal />}
    </>
  )
}

export default TimeSlots
